import React, { Component } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import formatDate from '../../../../shared/utils/formatDate';
import cx from 'classnames';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import withStores from '@studionand/ada-next/src/stores/withStores';
import atomicBlock from '@studionand/ada-next/src/legacy/atomicBlock';

moment.locale('de');

const styles = theme => ({
  root: {},
  float: {
    float: 'left',
  },
  input: {
    ...theme.typography.h6,
    border: 'none',
    display: 'inline-block',
    color: theme.editorPalette.primary.main,
    '&::placeholder': {
      color: theme.editorPalette.text.disabled,
    },
  },
  date: {
    marginBottom: 0,
  },
  noGutterBottom: {
    marginBottom: 0,
  },
});

const useStyles = makeStyles(styles);

const PlaceInput = withStores('pagesStore')(
  atomicBlock({ alignment: false, deletable: false })(
    observer(props => {
      const { pagesStore, placeholder } = props;
      const classes = useStyles();
      const placeValue =
        pagesStore.currentPage && pagesStore.currentPage.data.place;
      const isEmpty = !placeValue || placeValue.length === 0;
      const handleInput = e => {
        pagesStore.currentPage.updatePageData({ place: e.target.value });
      };
      if (!props.editMode) {
        return (
          <Typography
            className={classes.noGutterBottom}
            variant="h6"
            color="primary"
          >
            {placeValue}
          </Typography>
        );
      }
      return (
        <input
          size={isEmpty ? placeholder.length : placeValue.length}
          value={placeValue}
          placeholder={placeholder}
          className={cx(classes.input, { isEmpty })}
          onChange={handleInput}
        />
      );
    }),
  ),
);

PlaceInput.defaultProps = {
  placeholder: 'Ort',
};

@withStyles(styles)
@withStores('pagesStore', 'appStore')
@observer
class DatePicker extends Component { // eslint-disable-line

  static propTypes = {
    isActive: PropTypes.bool.isRequired,
    page: PropTypes.object.isRequired,
    readOnly: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super();
    const pageData = props.blockProps.page.data;
    this.state = {
      startDate: pageData.startDate ? moment(pageData.startDate) : null,
      endDate: pageData.endDate ? moment(pageData.endDate) : null,
      focusedInput: null,
    };
  }

  get page() {
    return this.props.blockProps.page;
  }

  get editorReadonly() {
    return this.props.blockProps.readOnly;
  }

  handleChange = ({ startDate: start, endDate: end }) => {
    if (start) {
      this.setState({ startDate: start });
      this.props.pagesStore.updatePageData(this.page.uuid, 'startDate', start);
    }
    if (end || end === null) {
      this.setState({ endDate: end });
      this.props.pagesStore.updatePageData(
        this.page.uuid,
        'endDate',
        end || '',
      );
    }
  };

  handleFocusChange = focusedInput => {
    this.setState({ isActive: !!focusedInput, focusedInput });
  };

  render() {
    const { appStore, classes } = this.props;
    const pageType = this.page.type;
    const place = this.page.data ? this.page.data.place : '';
    const { startDate, endDate, focusedInput, isActive } = this.state;
    const isArticle = pageType === 'artikel';
    const isEvent = pageType === 'event';
    const dateRangePicker = (
      <div>
        <DateRangePicker
          key="daterangepicker"
          minimumNights={0}
          isOutsideRange={() => false}
          startDatePlaceholderText="Startdatum"
          endDatePlaceholderText="Enddatum"
          hideKeyboardShortcutsPanel
          startDate={startDate}
          endDate={endDate}
          startDateId="startDate"
          endDateId="endDate"
          onDatesChange={this.handleChange}
          focusedInput={focusedInput}
          onFocusChange={focus =>
            this.setState({
              isActive: !!focus,
              focusedInput: focus,
            })
          }
        />
      </div>
    );
    const formattedDate = (
      <Typography
        className={classes.date}
        key="formattedDate"
        variant="h6"
        component={isArticle ? 'span' : 'div'}
        // className={cx(style.date)}
        onClick={() => {
          this.setState({ isActive: true, focusedInput: 'startDate' });
        }}
      >
        {formatDate({
          startDate,
          endDate,
          prefix: isArticle ? ', ' : null,
          fallback: isEvent ? 'Datum' : 'Stand',
        })}
        {isArticle && (
          <Box mr={1} ml={1} component="span">
            •
          </Box>
        )}
      </Typography>
    );
    return (
      <Box
        className={(classes.root, { [classes.float]: isArticle })}
        component={isArticle ? 'span' : 'div'}
        display="flex"
        justifyContent={isArticle ? 'flex-start' : 'center'}
      >
        {isArticle && (
          <PlaceInput
            editMode={appStore.editMode}
            value={place}
            elem="span"
            pageUuid={this.page.uuid}
          />
        )}
        {!appStore.editMode || !isActive ? formattedDate : dateRangePicker}
      </Box>
    );
  }
}

export default DatePicker;
